import { withStyles } from '@material-ui/core/styles';
import MuiBox from '@material-ui/core/Box';
import MuiTextField from '@material-ui/core/TextField';
import MuiSendIcon from '@mui/icons-material/Send';
import MuiTypography from '@material-ui/core/Typography';
import QueryResults from './query-results';
import { useState } from 'react';

const styles = theme => ({
  container: {
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: 'normal',
    marginBottom: theme.spacing(1),
  },
  prompt: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    width: '100%',
  },
  input: {
    width: '100%',
  },
});

const PromptBuilder = ({ ...props }) => {
  const { classes } = props;
  const [prompt, setPrompt] = useState('');

  return (
    <MuiBox className={classes.container}>
      <MuiTypography className={classes.title} variant="h6">
        Type your query here
      </MuiTypography>
      <form className={classes.form}>
        <MuiTextField className={classes.input} value={prompt} onChange={e => setPrompt(e.target.value)} />
        <QueryResults prompt={prompt} title="Query results">
          <MuiSendIcon />
        </QueryResults>
      </form>
    </MuiBox>
  );
};

export default withStyles(styles)(PromptBuilder);
